<template>
    <div class="annt-header">
        <div class="tag-view">
            <slot name="tagview"></slot>
        </div>
        <div class="func-menu">
            <slot name="funcMenu"></slot>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Header'
};
</script>

<style lang="less" scoped>
.annt-header {
    display: flex;
    height: 100%;
    .tag-view {
        flex: 1;
        margin-right: 20px;
    }
    .func-menu {
        white-space: nowrap;
        overflow: auto;
        // 某些浏览器里会出现垂直滚动条，要去掉
        overflow-y: hidden;
        // margin-right: 20px;
    }
}
</style>
